export const generalAdsUrl = () => `general-ads`;
export const activateAdsUrl = (id: number) => `general-ads/${id}/activation`;
export const deactivateAdsUrl = (id: number) => `general-ads/deactivate/${id}`;
export const getGeneralAdByIdUrl = (id: number) => `general-ads/${id}`;
